import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { AdminShell } from './features/admin/AdminShell.tsx';
import { Confirmation } from './features/booking/Confirmation.tsx';
import { EventPage } from './features/booking/EventPage.tsx';
import { Home } from './features/booking/Home.tsx';
import { Privacy } from './features/booking/Privacy.tsx';
import { WaitingRoomRoute } from './features/booking/WaitingRoom.tsx';
import { initTheme } from './lib/theme.ts';
import './styles/globals.css';

// Apply persisted/system theme before first paint — avoids flash.
initTheme();

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'etkinlik', element: <EventPage /> },
      { path: 'onay/:reference', element: <Confirmation /> },
      { path: 'bekleme', element: <WaitingRoomRoute /> },
      { path: 'gizlilik', element: <Privacy /> },
      { path: 'admin/*', element: <AdminShell /> },
    ],
  },
]);

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
